const isBackend = () => {
  return window['wp'] !== undefined;
}


const isElementInViewport = (el) => {
  if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
  }

  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
  );
}


export { isBackend, isElementInViewport };
